import { IconButton } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import {
  FormControl
} from '@sketchpixy/rubix';
import { ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'react-redux';
import { DND_ELEMENTS } from '../../_config/consts.js';
import {
  clientToStoredMapCoordinates,
  getMapCanvasBBox,
  MAP_MARKER_HALF_CLIENT,
  storedMapCoordinatesToMarkerPosition,
} from '../../_config/mapCoordinates.js';
import CloseCircleIconCustom from '../CustomIcons/CloseCircleIconCustom.jsx';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MapLockRow from '../Maps/MapLockRow.jsx';
import FloorElementPoint from './FloorElementPoint.jsx';

function MapBuilderLocksList({ searchText, selectedMapId, onAppendSmartLocks }) {
  const smartLocks = useSelector((state) => state.locks.data);
  
  if (!smartLocks || smartLocks.content.length === 0) {
    return <EmptyView
      title="noLock"
      iconName="icon-simple-line-icons-user-following"
    />
  }
  const filteredSmartLocks = searchText && searchText.length >= 0 ? _.filter(smartLocks.content, res => res.name.toLowerCase().includes(searchText.toLowerCase())) : smartLocks.content;
  return (
      <InfiniteScroll
        initialLoad={false}
        loadMore={() => onAppendSmartLocks(smartLocks.pagination && smartLocks.pagination.number + 1)}
        hasMore={smartLocks.pagination && !smartLocks.pagination.last}
        loader={<ListLoadingView containerStyle={{ backgroundColor: 'transparent' }} />}
        useWindow={false}
      >
        {_.map(filteredSmartLocks, (el) => (<MapLockRow key={el.id} locationMedia={el.locationMedia} model={el.model} selectedMapId={selectedMapId} id={el.id} name={el.name} />))}
      </InfiniteScroll>
  )
}

export default function FloorPlanEditor({ onPositionElementOnMap, onRemoveElementFromMap, onAppendSmartLocks }) {
  const [dropCanvasBbox, setDropCanvasBbox] = useState(null);
  const floorPlan = useSelector((state) => state.floorPlans.selectedFloorPlan);
  const smartLocks = useSelector((state) => state.locks.data);
  const [searchText, setSearchText] = useState('');
  const imageSource = floorPlan && floorPlan.link ? floorPlan.link : '';

  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: [DND_ELEMENTS.SMART_LOCK_ROW, DND_ELEMENTS.SMART_LOCK_POINT],
      canDrop: () => true,
      drop: (item, monitor) => {
        const isPointReposition = monitor.getItemType() === DND_ELEMENTS.SMART_LOCK_POINT;
        // Point re-drag: place by marker top-left (already works).
        // List drop: cursor should be the CENTER of the new 50x50 marker.
        let dropCoordinate = isPointReposition
          ? (monitor.getSourceClientOffset() || monitor.getClientOffset())
          : monitor.getClientOffset();
        if (!dropCoordinate) return;
        if (!isPointReposition) {
          dropCoordinate = {
            x: dropCoordinate.x - MAP_MARKER_HALF_CLIENT,
            y: dropCoordinate.y - MAP_MARKER_HALF_CLIENT,
          };
        }
        const dropCanvas = document.getElementById('dropCanvas');
        const normalizedDropCoordinates = clientToStoredMapCoordinates(
          dropCanvas,
          dropCoordinate.x,
          dropCoordinate.y,
        );
        if (!normalizedDropCoordinates) return;
        onPositionElementOnMap(item, normalizedDropCoordinates);
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }));

  const refreshMapLayout = () => {
    const dropCanvas = document.getElementById('dropCanvas');
    setDropCanvasBbox(getMapCanvasBBox(dropCanvas));
  };

  useEffect(() => {
    refreshMapLayout();
    window.addEventListener('resize', refreshMapLayout);
    return () => window.removeEventListener('resize', refreshMapLayout);
  }, [imageSource]);


  return (
    <div className="card-noHover" style={{ margin: 20, marginLeft:0, marginTop: 0, padding: 0, overflow: 'scroll', height: '120vh', width: '98%', zIndex: 0 }}>
      <div style={{ height: '99vh', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div style={{ height: '95vh', position: 'relative', overflow: 'scroll' }} onScroll={refreshMapLayout}>
            <img id="dropCanvas" ref={drop} src={imageSource} style={{ height: '100%', display: 'flex', flex: 1, objectFit: 'contain' }} onLoad={refreshMapLayout} />
            {_.map(smartLocks && smartLocks.content, (smartLock) =>  {
              if (!smartLock.locationCoordinates || !smartLock.locationMedia || smartLock.locationMedia.id !== floorPlan.id) {
                return null;
              }
              const resourceX = smartLock.locationCoordinates.split(';')[0];
              const resourceY = smartLock.locationCoordinates.split(';')[1];
              if (!dropCanvasBbox) return null;
              const { x, y } = storedMapCoordinatesToMarkerPosition(resourceX, resourceY, dropCanvasBbox);
              return (
                <FloorElementPoint
                  key={smartLock.id}
                  element={smartLock}
                  x={x}
                  y={y}
                  onRemoveElementFromMap={() => onRemoveElementFromMap(smartLock)}
                />
              );
            })}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column',  backgroundColor: 'lightgray', paddingTop: 10 }}>
            <div style={{ marginBottom: 5, display: 'flex', paddingLeft: 10, position: 'relative', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <FormControl
                type="text"
                name="search"
                value={searchText}
                placeholder={L20NContext.getSync('searchSmartLock')}
                className="form-control-rounded"
                onChange={e => setSearchText(e.target.value)}
              />
              {searchText ? (
                <IconButton style={{ position: 'absolute', right: '10px' }} onClick={() => setSearchText('')}>
                  <CloseCircleIconCustom style={{ width: 20 }} />
                </IconButton>
              ) : (
                <Search style={{ position: 'absolute', right: '20px', fontSize: 20 }} />
              )}
            </div>
            <div style={{ height: '100vh', width: 300, overflow: 'auto', paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 200 }}>
              <MapBuilderLocksList
                searchText={searchText}
                selectedMapId={floorPlan && floorPlan.id}
                onAppendSmartLocks={page => onAppendSmartLocks(page)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
